module.exports = __webpack_public_path__ + "img/arrow-down-icon.674a0191.svg";